import {
  ListItem,
  Badge,
  Checkbox,
  Paper,
  Stack,
  Box,
  Typography,
  Tooltip,
  IconButton,
  Grid,
  Link,
} from "@mui/material";
import Edit from "@mui/icons-material/Edit";
import ChatIcon from "@mui/icons-material/Chat";
import ReportProblem from "@mui/icons-material/ReportProblem";
// import EditDocument from "@mui/icons-material/EditDocument";
// import Checklist from "@mui/icons-material/Checklist";
// import Photo from "@mui/icons-material/Photo";
import InfoIcon from "@mui/icons-material/Info";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { paginateArray } from "../helpers/paginateArray";
import UserControl from "../Dialogs/UserControl";
dayjs.extend(relativeTime);

export default function ObservationCard(props) {
  return (
    <div>
      {paginateArray(props.observations, props.page, props.rowsPerPage).map(
        (obs, idx) => (
          <ListItem key={idx} style={{ padding: 0 }}>
            <Paper
              elevation={6}
              style={{ width: "100%", marginTop: 10, marginBottom: 10 }}
            >
              <div style={{ padding: 20 }}>
                <Box
                  sx={{
                    width: "100%",
                    height: 10,
                    borderRadius: 1,
                    bgcolor: obs.Selected ? "secondary.light" : "primary.main",
                    // "&:hover": {
                    //   bgcolor: "primary.dark",
                    // },
                  }}
                />
                <Grid container spacing={0}>
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        id={obs.id}
                        name={obs.id}
                        checked={obs.Selected ? obs.Selected : false}
                        onChange={props.handleChecked}
                      />
                      <Link
                        variant="h6"
                        gutterBottom
                        underline="hover"
                        href={`/project/${props.projectId}/observation/${obs.id}`}
                        color="secondary.main"
                      >{`Observation No: ${obs["No"]}`}</Link>
                    </Stack>
                  </Grid>

                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        color="secondary.light"
                      >{`Date:`}</Typography>
                      <Typography style={{ marginLeft: 6 }}>
                        {
                          `${new Date(
                            obs.Date.seconds * 1000,
                          ).toLocaleDateString()} 
                          `
                          // (${dayjs(
                          //   new Date(obs.Date.seconds * 1000)
                          // ).fromNow()})
                        }
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        color="secondary.light"
                      >{`Description:`}</Typography>
                      <Typography
                        style={{ marginLeft: 6 }}
                      >{`${obs.Description.slice(0, 10)}${
                        obs.Description.length > 10 ? ".." : ""
                      }`}</Typography>
                    </Stack>
                  </Grid>

                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        color="secondary.light"
                      >{`Location:`}</Typography>
                      <Typography
                        style={{ marginLeft: 6 }}
                      >{`${obs.Location}`}</Typography>
                    </Stack>
                  </Grid>

                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <UserControl
                      isCreator={true}
                      user={obs["Created By"].toString()}
                      uid={obs["Creator UID"]?obs["Creator UID"]:obs["Created By"]}
                    />
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="caption"
                        gutterBottom
                        color="secondary.light"
                      >{`Created Date:`}</Typography>
                      <Typography
                        style={{ marginLeft: 4 }}
                        variant="caption"
                        gutterBottom
                      >
                        {`${new Date(
                          obs["Created Date"].seconds * 1000,
                        ).toLocaleDateString()}
              
                 (${dayjs(
                   new Date(obs["Created Date"].seconds * 1000),
                 ).fromNow()})`}
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <UserControl
                      isCreator={false}
                      user={obs["Modified By"].toString()}
                      uid={obs["Modifier UID"]?obs["Modifier UID"]:obs["Modified By"]}
                    />
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="caption"
                        gutterBottom
                        color="secondary.light"
                      >{`Modified Date:`}</Typography>
                      <Typography
                        style={{ marginLeft: 4 }}
                        variant="caption"
                        gutterBottom
                      >
                        {`${new Date(
                          obs["Modified Date"].seconds * 1000,
                        ).toLocaleDateString()}  (${dayjs(
                          new Date(obs["Modified Date"].seconds * 1000),
                        ).fromNow()})`}
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid
                    sx={{
                      display: {
                        xs: "none",
                        sm: "none",
                        md: "none",
                        lg: "block",
                      },
                    }}
                    size={{ lg: 3 }}
                  />
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Stack
                      style={{ paddingTop: 6 }}
                      direction="row"
                      spacing={1}
                      sx={{
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <Tooltip title="Edit">
                        <IconButton
                          aria-label="Edit"
                          disabled={!props.allowUpdate}
                          size="large"
                          onClick={() => props.onEdit(obs.id)}
                          color={obs.Selected ? "primary" : "secondary.light"}
                        >
                          <Edit fontSize="inherit" />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Details">
                        <IconButton
                          aria-label="Details"
                          size="large"
                          onClick={() =>
                            props.onDetailsClick({ id: obs.id, focus: "" })
                          }
                          color={obs.Selected ? "primary" : "secondary.light"}
                        >
                          <InfoIcon fontSize="inherit" />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title={`Files (${obs.fileCount})`}>
                        <IconButton
                          aria-label="Files"
                          size="large"
                          color={obs.Selected ? "primary" : "primary.light"}
                          onClick={() =>
                            props.onDetailsClick({
                              id: obs.id,
                              focus: "files",
                            })
                          }
                        >
                          <Badge
                            badgeContent={obs.fileCount}
                            sx={{
                              "& .MuiBadge-badge": {
                                color: "primary.contrastText",
                                backgroundColor: "secondary.light",
                              },
                            }}
                            showZero
                          >
                            <FileCopyIcon fontSize="inherit" />
                          </Badge>
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={`Comments (${obs.commentCount})`}>
                        <IconButton
                          aria-label="Comments"
                          size="large"
                          color={obs.Selected ? "primary" : "primary.light"}
                          onClick={() =>
                            props.onDetailsClick({
                              id: obs.id,
                              focus: "comments",
                            })
                          }
                        >
                          <Badge
                            badgeContent={obs.commentCount}
                            sx={{
                              "& .MuiBadge-badge": {
                                color: "primary.contrastText",
                                backgroundColor: "secondary.light",
                              },
                            }}
                            showZero
                          >
                            <ChatIcon fontSize="inherit" />
                          </Badge>
                        </IconButton>
                      </Tooltip>

                      <Tooltip title={`Issues (${obs.issueCount})`}>
                        <IconButton
                          aria-label="Issues"
                          size="large"
                          color={obs.Selected ? "primary" : "primary.light"}
                        >
                          <Badge
                            badgeContent={obs.issueCount}
                            onClick={() =>
                              props.onDetailsClick({
                                id: obs.id,
                                focus: "issues",
                              })
                            }
                            sx={{
                              "& .MuiBadge-badge": {
                                color: "primary.contrastText",
                                backgroundColor: "secondary.light",
                              },
                            }}
                            showZero
                          >
                            <ReportProblem fontSize="inherit" />
                          </Badge>
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </Grid>
                </Grid>
              </div>
            </Paper>
          </ListItem>
        ),
      )}
    </div>
  );
}
